var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-content',[_c('el-header',{attrs:{"slot":"header","title":_vm.$t('modules.actionsboard.page_titles.fasts')},slot:"header"}),_c('div',{},[_c('FastActions')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }